import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AuthGuard } from "@/auth/AuthGuard";
import Enroll from "@/auth/Enroll";
import { Layout } from "@/components/Layout";
import Browse from "@/views/Browse";
import Cook from "@/views/Cook";
import Discover from "@/views/Discover";
import Inventory from "@/views/Inventory";
import Menu from "@/views/Menu";
import RecipeDetail from "@/views/RecipeDetail";
import Shopping from "@/views/Shopping";
import { isPhone } from "@/phone";

// One route per mode; the Layout (header, side panel, chef bar) persists
// across navigation. Browse is the default landing view — on a phone it is
// the shopping list, the mode you want in the supermarket. Everything except
// /enroll/<token> (public by design — users enroll their authenticator
// BEFORE they can log in) sits behind the AuthGuard; the 30-day sliding
// session means the tablet sees the login screen roughly never.
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/enroll/:token" element={<Enroll />} />
        <Route
          path="*"
          element={
            <AuthGuard>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to={isPhone() ? "/shopping" : "/browse"} replace />} />
                  <Route path="/inventory" element={<Inventory />} />
                  <Route path="/browse" element={<Browse />} />
                  <Route path="/browse/:id" element={<RecipeDetail />} />
                  <Route path="/cook" element={<Cook />} />
                  <Route path="/menu" element={<Menu />} />
                  <Route path="/shopping" element={<Shopping />} />
                  <Route path="/discover" element={<Discover />} />
                  <Route path="*" element={<Navigate to="/browse" replace />} />
                </Routes>
              </Layout>
            </AuthGuard>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
